import React, { useEffect, useState } from 'react';

const AlertModal = (props) => {
  let favoriteSong = props.show ? "https://www.youtube.com/embed/ayEMo-lQuw8?si=UiDIDaqPM80Lq34j" : "";
  return (
    <div style={{ display: props?.show ? 'block' : 'none' }} className='alert-modal-container'>
        <div className="alert-modal-overlay" onClick={() => props?.setShow(false)}></div>
        <div className="alert-modal">
            <div className="alert-modal-header">
                <h2 className="lucky-font">Alert</h2>
                <button className="alert-modal-close-button" onClick={() => props?.setShow(false)}>💩</button>
            </div>
            <div className='alert-modal-body lato-font'>
                <p>The number is down... Please check back soon!</p>
                {props.show && <iframe width="auto" height="auto" src={favoriteSong} title="What do I know?" frameBorder="0" allowFullScreen="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin"></iframe>}
                <button className="alert-modal-body-close-button" onClick={() => props?.setShow(false)}>Close</button>
            </div>
        </div>
    </div>
  );

};

export default AlertModal;